import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLeaderboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLeaderboard"><Path d="M8 6.5H16V17.5H8V6.5Z" stroke="currentColor"/><Path d="M1.25 9H8V17.5H1.25V9Z" stroke="currentColor"/><Path d="M16 10.5H23V17.5H16V10.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconLeaderboard;
